import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/Button';
import Caret from '../../components/Caret';
import SVGIcon from '../../components/SVGIcon';
import checkIcon from '../../icons/check.svg';
import OnboardingActions from '../OnboardingActions';
import useOnboardingData from '../useOnboardingData';
import styles from './TutorialListItem.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  to: PropTypes.string,
};

const defaultProps = {
  to: null,
};

const TutorialListItem = ({ icon, name, children, to, onClick }) => {
  const { onReset, onboarding } = useOnboardingData(name);
  const dispatch = useDispatch();
  const handleClick = () => {
    onReset();
    dispatch(OnboardingActions.setActiveTutorial(name));
    onClick();
  };

  return (
    <Button className={styles.container} onClick={handleClick} to={to}>
      {icon}
      <div className={styles.content}>{children}</div>
      {onboarding && (onboarding.completedAt || onboarding.skippedAt) ? (
        <SVGIcon className={styles.check}>{checkIcon}</SVGIcon>
      ) : (
        <Caret direction="right" size="regular" />
      )}
    </Button>
  );
};

TutorialListItem.propTypes = propTypes;
TutorialListItem.defaultProps = defaultProps;

export default TutorialListItem;
